import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CATEGORIES } from "@/lib/api";
import api from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function Categories() {
  const [counts, setCounts] = useState({});
  useEffect(() => {
    api.get("/stats").then((r) => setCounts(r.data.by_category || {})).catch(() => {});
  }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-6 py-12">
      <div className="border-b border-black/15 pb-6 mb-10">
        <div className="overline">/the categories</div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter mt-2">Eight fronts</h1>
        <p className="mt-3 text-base text-[#333] max-w-2xl">
          The rollback (and protection) of women's rights happens across distinct regulatory fronts.
          Use these categories to focus your research.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {CATEGORIES.map((c, i) => (
          <Link
            key={c.slug}
            to={`/categories/${c.slug}`}
            data-testid={`big-category-${c.slug}`}
            className="group block bg-white border border-black/15 hover:bg-black hover:text-white transition-colors duration-150 p-8"
          >
            <div className="flex items-start justify-between">
              <div>
                <div className="font-mono-plex text-[11px] tracking-[0.25em] uppercase opacity-60">№ {String(i + 1).padStart(2, "0")}</div>
                <h2 className="font-display text-3xl font-bold tracking-tight mt-2">{c.label}</h2>
                <p className="mt-3 text-base opacity-80 max-w-md">{c.blurb}</p>
              </div>
              <div className="font-display text-5xl font-black opacity-90">
                {counts[c.slug] || 0}
              </div>
            </div>
            <div className="mt-6 flex items-center gap-2 font-mono-plex text-xs uppercase tracking-wider">
              Browse entries <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
